import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Spinner } from '../components/ui';

export const LoginPage: React.FC = () => {
  const { isAuthenticated, login, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate('/');
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-10 w-10" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <span className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-saffron-500/15 text-saffron-300 ring-1 ring-saffron-500/30">
            <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
              <path d="M7 11a5 5 0 0 1 10 0M5 11h14l-1.2 8.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8z" />
            </svg>
          </span>
          <h1 className="font-display text-3xl font-bold text-cream-50">Chefty Console</h1>
          <p className="mt-2 text-sm text-cream-400">Operator access — sign in to continue</p>
        </div>

        <div className="rounded-2xl border border-cream-600/15 bg-ink-900/70 p-6 backdrop-blur-sm">
          <button
            onClick={login}
            className="w-full rounded-xl bg-saffron-500 py-2.5 text-sm font-semibold text-ink-950 transition-colors hover:bg-saffron-400"
          >
            Sign in with Keycloak
          </button>
          <p className="mt-3 text-center text-xs text-cream-600">
            Requires the <span className="font-mono text-cream-400">admin</span> realm role.
          </p>
        </div>
      </div>
    </div>
  );
};
